import AddressConfig from './AddressConfig';

// 结算页埋点配置
const config = {
  // 结算主页
  'Checkout.getdata.result': {
    operation: ['VISIBLE'],
    title: '结算页报错',
    c: {
      type: 'constant',
      value: 'error',
    },
    d: {
      type: 'constant',
      value: 1,
    },
    iid: {
      type: 'variable',
      func: ({ e }) => {
        return `e=${e}`;
      },
    },
  },
  'Checkout.checkout.result': {
    operation: ['VISIBLE'],
    title: '结算页报错',
    c: {
      type: 'constant',
      value: 'checkout_result',
    },
    d: {
      type: 'constant',
      value: 1,
    },
    iid: {
      type: 'variable',
      func: ({ type, message, traceId }) => {
        return `type=${type}&message=${message}&traceId=${traceId}`;
      },
    },
  },
  'Checkout.list': {
    operation: ['VISIBLE'],
    title: '结算大列表',
    // 发票
    getParse_invoice: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const { pageName } = args;
        const result = [
          {
            type: 'invoice',
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'invoice',
            d: 1,
          },
        ];
        return result;
      },
    },
    // 支付人信息
    getParse_payerinfo: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const { pageName } = args;
        const result = [
          {
            type: 'payerinfo',
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'real_user',
            d: 1,
          },
        ];
        return result;
      },
    },
    // 公告
    getParse_bulletinList: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const { pageName } = args;
        const result = [
          {
            type: 'bulletin',
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'bulletin',
            d: 1,
          },
        ];
        return result;
      },
    },
    // 地址
    getParse_address: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const shipmentId = item.item.shipmentId;
        const { pageName } = args;
        const result = [
          {
            type: 'address',
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            c: shipmentId === 25 ? 'shop_addre' : 'addr',
            d: 1,
          },
        ];
        return result;
      },
    },
    // 价格明细
    getParse_feemsg: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        // console.log('result======:', result);
        const { pageName } = args;
        const temp = (item?.item?.data && item?.item?.data[0]) || {};
        const result = [
          {
            type: 'feemsg',
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'coupon',
            d: 1,
          },
        ];
        if (temp?.ecardInfo?.normalShow) {
          result.push({
            type: 'feemsg',
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'card',
            d: 1,
            iid: '',
          });
        }
        if (temp?.ecardInfo?.recycleShow) {
          result.push({
            type: 'feemsg',
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'cashcoupon',
            d: 1,
            iid: '',
          });
        }
        if (temp?.shoppingCoupon?.isShow) {
          result.push({
            type: 'feemsg',
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'voucher',
            d: 1,
            iid: '',
          });
        }
        return result;
      },
    },
    // IMEI校验
    getParse_imeicheck: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const { pageName } = args;
        const result = [
          {
            type: 'imeicheck',
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'device_confirm_all',
            d: 1,
          },
        ];
        return result;
      },
    },
  },
  // 公告
  'Checkout.bulletin': {
    operation: ['VISIBLE'],
    title: '结算页公告',
    c: {
      type: 'constant',
      value: 'bulletin',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 关闭公告
  'Checkout.bulletin.close': {
    operation: ['TOUCH'],
    title: '结算页公告关闭',
    c: {
      type: 'constant',
      value: 'bulletin_close',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 地址栏
  'Checkout.address.addr': {
    operation: ['TOUCH'],
    title: '结算地址栏',
    c: {
      type: 'variable',
      func: function ({ shipmentId }) {
        if (shipmentId === 139) {
          return 'flash_addre';
        }
        return shipmentId === 25 ? 'shop_addre' : 'addr';
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid({ storeInfo }) {
        if (storeInfo) {
          return 'org_id=' + storeInfo.orgCode;
        }
      },
    },
  },
  'Checkout.address.addr_visible': {
    operation: ['VISIBLE'],
    title: '结算地址栏',
    c: {
      type: 'variable',
      func: function ({ shipmentId }) {
        if (shipmentId === 139) {
          return 'flash_addre';
        }
        return shipmentId === 25 ? 'shop_addre' : 'addr';
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid({ storeInfo }) {
        // return aa;
        if (storeInfo) {
          return 'org_id=' + storeInfo.orgCode;
        }
      },
    },
  },
  // 实名
  'Checkout.payerInfo': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '结算实名栏',
    c: {
      type: 'constant',
      value: 'real_user',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid() {
        const aa = {
          privacy_flags: [
            { scenario_id: 3, value: '' },
            { scenario_id: 6, value: '' },
          ],
        };
        return aa;
      },
    },
  },
  // 地址弹窗-地址选择
  'Checkout.address.addrChoice': AddressConfig['Address.common.addrChoice'],
  // 地址弹窗-地址编辑
  'Checkout.address.editAddr': AddressConfig['Address.common.editAddr'],
  // 地址弹窗-去新建地址
  'Checkout.address.addAddr': AddressConfig['Address.common.addAddr'],
  // 结算明细
  'Checkout.feeinfo.coupon': {
    operation: ['TOUCH'],
    title: '结算明细优惠券',
    c: {
      type: 'constant',
      value: 'coupon',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Checkout.feeinfo.ecard': {
    operation: ['TOUCH'],
    title: '结算明细礼品卡',
    c: {
      type: 'constant',
      value: 'card',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid({ url }) {
        return 'u=' + url || '';
      },
    },
  },
  'Checkout.feeinfo.cash': {
    operation: ['TOUCH'],
    title: '现金券',
    c: {
      type: 'constant',
      value: 'cashcoupon',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid({ url }) {
        return 'u=' + url || '';
      },
    },
  },
  'Checkout.feeinfo.redpacket': {
    operation: ['TOUCH'],
    title: '红包',
    c: {
      type: 'constant',
      value: 'redpacket',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Checkout.feeinfo.voucher': {
    operation: ['TOUCH'],
    title: '消费券',
    c: {
      type: 'constant',
      value: 'voucher',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid({ url }) {
        return 'u=' + url || '';
      },
    },
  },
  // 发票
  'Checkout.invoice': {
    operation: ['TOUCH'],
    title: '发票',
    c: {
      type: 'constant',
      value: 'invoice',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 提交订单按钮
  'Checkout.pay.button': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '去支付',
    c: {
      type: 'constant',
      value: 'pay',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid({ orderId, url, originCheckoutData: resultData, rqid }) {
        const skus = [];
        resultData?.merchantItems?.forEach((item) => {
          item?.data?.forEach((subItem) => {
            skus.push({
              ssuId: subItem?.ssuId,
              itemId: subItem?.itemId,
              count: subItem?.count,
            });
          });
        });
        let delivery_type = 'online';
        if (resultData?.storeInfo?.orgCode && resultData?.deliveryInfo?.shipmentList?.[0]) {
          delivery_type = resultData?.deliveryInfo?.shipmentList?.[0].name === '自提' ? 'off_line' : 'flash';
        }
        const tag = `pay_method=1&rqid=${rqid}&n=${resultData.totalMoney}&delivery_type=${delivery_type}&store_id=${
          resultData?.storeInfo?.orgCode || ''
        }&skus=${encodeURIComponent(JSON.stringify(skus))}`;
        if (orderId && url) {
          return `${tag}&u=${url}&orderId=${orderId}`;
        } else {
          return tag;
        }
      },
    },
  },
  // 关闭实名弹窗
  'Checkout.payerinfo.close': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '关闭实名弹窗',
    c: {
      type: 'constant',
      value: 'real_confirm_close',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 提交实名弹窗
  'Checkout.payerinfo.post': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '提交实名弹窗信息',
    c: {
      type: 'constant',
      value: 'real_user_submit',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'constant',
      value: {
        privacy_flags: [
          { scenario_id: 3, value: '' },
          { scenario_id: 6, value: '' },
        ],
      },
    },
  },
  // 关闭无感配网弹窗
  'Checkout.addmijia.close': {
    operation: ['TOUCH'],
    title: '关闭无感配网弹窗',
    c: {
      type: 'constant',
      value: 'addmijia_close',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 确认无感配网
  'Checkout.addmijia.confirm': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '关闭无感配网弹窗',
    c: {
      type: 'constant',
      value: 'addmijia_confirm',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 无感配网服务
  'Checkout.addmijia': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '关闭无感配网弹窗',
    c: {
      type: 'constant',
      value: 'addmijia',
    },
    d: {
      type: 'variable',
      func: function ({ index }) {
        return index || 0;
      },
    },
  },
  // 取货弹窗关闭
  'Checkout.picktime.close': {
    operation: ['TOUCH'],
    title: '关闭取货弹窗',
    c: {
      type: 'constant',
      value: 'shop_picktime_close',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 取货弹窗确认
  'Checkout.picktime.confirm': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '取货弹窗确认',
    c: {
      type: 'constant',
      value: 'shop_picktime_confirm',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 关闭预约配送时间弹窗
  'Checkout.selectflashtime.close': {
    operation: ['TOUCH'],
    title: '关闭预约配送时间弹窗',
    c: {
      type: 'constant',
      value: 'select_flashtime_close',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 预约配送时间弹窗
  'Checkout.selectflashtime.confirm': {
    operation: ['TOUCH'],
    title: '配送时间弹窗确认',
    c: {
      type: 'constant',
      value: 'select_flashtime_confirm',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 礼品卡验证码弹窗
  'Checkout.ecard.check': {
    operation: ['VISIBLE'],
    title: '礼品卡验证码弹窗',
    c: {
      type: 'variable',
      func: ({ ecardType }) => {
        return ecardType === 'ecard' ? 'ordergiftcard_check_pop' : 'cashcoupons_pop';
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 关闭礼品卡验证码弹窗
  'Checkout.ecard.close': {
    operation: ['TOUCH'],
    title: '关闭礼品卡验证码弹窗',
    c: {
      type: 'variable',
      func: ({ ecardType }) => {
        return ecardType === 'ecard' ? 'close_ordercashcoupons__giftcard' : 'close_ordercashcoupons_cashcoupons';
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 礼品卡获取验证码
  'Checkout.ecard.getvcode': {
    operation: ['TOUCH'],
    title: '礼品卡获取验证码',
    c: {
      type: 'variable',
      func: ({ ecardType }) => {
        return ecardType === 'ecard' ? 'obtaincode_phone_giftcard' : 'obtaincode_phone_cashcoupons';
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: ({ status }) => {
        return `status=${status}`;
      },
    },
  },
  // 取消礼品卡使用
  'Checkout.ecard.cancel': {
    operation: ['TOUCH'],
    title: '取消礼品卡使用',
    c: {
      type: 'variable',
      func: ({ ecardType }) => {
        return ecardType === 'ecard' ? 'cancel_giftcard' : 'cancel_cashcoupons';
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 确认礼品卡使用
  'Checkout.ecard.confirm': {
    operation: ['TOUCH'],
    title: '确认礼品卡使用',
    c: {
      type: 'variable',
      func: ({ ecardType }) => {
        return ecardType === 'ecard' ? 'order_giftcard' : 'order_cashcoupons';
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },

  // 裸号取消弹窗
  'Checkout.nophone.cancel': {
    operation: ['TOUCH'],
    title: '裸号取消弹窗',
    c: {
      type: 'constant',
      value: 'nophone_cancel',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 裸号去绑定
  'Checkout.nophone.tobind': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '裸号去绑定',
    c: {
      type: 'constant',
      value: 'nophone_tobind',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 大家电关闭
  'Checkout.largehousehold.close': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '大家电关闭',
    c: {
      type: 'variable',
      func: ({ type }) => {
        return type && type === 'time' ? 'largehousetime_close' : 'largehousehold_close';
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 大家电确定
  'Checkout.largehousehold.confirm': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '大家电确定',
    c: {
      type: 'variable',
      func: ({ type }) => {
        return type && type === 'time' ? 'largehousetime_confirm' : 'largehousehold_confirm';
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 闪送选择时间楼层
  'Chekcout.select.flashtime': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '闪送选择时间楼层',
    c: {
      type: 'constant',
      value: 'select_flashtime',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 大家电选择时间楼层
  'Chekcout.largehousehold.selectdate': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '大家电选择时间楼层',
    c: {
      type: 'variable',
      func: ({ type }) => {
        return type == 2 ? 'largehousehold_selecttime' : 'largehousehold_selectdate';
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: (traceData) => {
        const deliveryMap = {
          DISPATCH_TODAY: 3,
          DISPATCH_TOMORROW: 4,
          ARRIVAL_TODAY: 1,
          ARRIVAL_TOMORROW: 2,
        };
        const { productId, can_change_big_electric } = traceData;
        return `type=${
          deliveryMap[can_change_big_electric?.[0]?.performanceTag || ''] || '0'
        }&skus=${encodeURIComponent(
          JSON.stringify([
            {
              count: 1,
              product_id: productId,
            },
          ]),
        )}`;
      },
    },
  },
  'Chekcout.normal.date': {
    operation: ['VISIBLE'],
    title: '大家电选择时间楼层',
    c: {
      type: 'variable',
      func: () => {
        return '3Cdelivery_time';
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: (traceData) => {
        const { productId, can_change_big_electric, cant_change } = traceData;
        const deliveryMap = {
          DISPATCH_TODAY: 3,
          DISPATCH_TOMORROW: 4,
          ARRIVAL_TODAY: 1,
          ARRIVAL_TOMORROW: 2,
        };
        return `type=${
          deliveryMap[
            can_change_big_electric?.length
              ? can_change_big_electric?.[0]?.performanceTag || ''
              : cant_change?.[0]?.performanceTag || ''
          ] || '0'
        }&skus=${encodeURIComponent(
          JSON.stringify([
            {
              count: 1,
              product_id: productId,
            },
          ]),
        )}`;
      },
    },
  },
  // 去定位
  'Checkout.address.position': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '去定位',
    c: {
      type: 'constant',
      value: 'to_position',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 定制
  'Checkout.customBtn': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '定制商品',
    c: {
      type: 'constant',
      value: 'customize_review',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 合约机
  'Checkout.contractphone.tipBtn': {
    operation: ['TOUCH'],
    title: '合约机提示',
    c: {
      type: 'constant',
      value: 'contractphone_tips',
    },
    d: {
      type: 'variable',
      func: function (traceData) {
        const { index = 1 } = traceData || {};
        return `${index}`;
      },
    },
  },
  'Checkout.contractphone.benefit': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '合约机优惠信息',
    c: {
      type: 'constant',
      value: 'contractphone_benefit',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Checkout.contractphone.checkmore': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '合约机查看更多信息',
    c: {
      type: 'constant',
      value: 'contractphone_checkmore',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 优惠券
  'Checkout.coupon.tabAvaliable': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '优惠券tab可用',
    c: {
      type: 'constant',
      value: 'available_coupon',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Checkout.coupon.tabUnavaliable': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '优惠券tab不可用',
    c: {
      type: 'constant',
      value: 'unavailable_coupon',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Checkout.coupon.couponItemVisible': {
    operation: ['VISIBLE'],
    title: '优惠券item曝光',
    getParse: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const { scmv2, pageName } = args;
        const couponId = item.item?.couponId;
        const result = [
          {
            type: 'rec_list',
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'couponItem',
            d: `${item.index + 1}`,
            iid: `couponid=${couponId}`,
            scmv2: scmv2,
          },
        ];
        return result;
      },
    },
  },
  'Checkout.coupon.couponItemTouch': {
    operation: ['TOUCH'],
    title: '优惠券item点击',
    c: {
      type: 'constant',
      value: 'couponItem',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { couponId = '' } = traceData || {};
        return 'couponid=' + couponId;
      },
    },
  },
  'Checkout.coupon.selectBest': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '使用推荐优惠券',
    c: {
      type: 'constant',
      value: 'select_best_coupon',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Checkout.coupon.confirm': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '使用推荐优惠券',
    c: {
      type: 'constant',
      value: 'coupon_use_confirm',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const couponIds = Object.values(traceData || {}).map((item) => item.couponId);
        return 'couponid=' + couponIds.join(',');
      },
    },
  },
  'Checkout.invalid.closeBtn': {
    operation: ['TOUCH'],
    title: '失效弹窗关闭点击',
    c: {
      type: 'constant',
      value: 'Invalidpop_close',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Checkout.invalid.backCartBtn': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '失效弹窗返回购物车',
    c: {
      type: 'constant',
      value: 'Invalidpop_backtocart',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Checkout.invalid.confirmBtn': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '失效弹窗确认',
    c: {
      type: 'constant',
      value: 'Invalidpop_confirm',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Checkout.invalid.alert_addresswarn_lbtn': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '失效弹窗确认',
    c: {
      type: 'constant',
      value: 'alert_addresswarn_lbtn',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const shipmentId = traceData?.traceData || 2;
        if ([25, 139].includes(shipmentId) > -1) {
          return `type=${shipmentId === 25 ? 2 : 1}`;
        }
      },
    },
  },
  'Checkout.invalid.alert_addresswarn_rbtn': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '失效弹窗确认',
    c: {
      type: 'constant',
      value: 'alert_addresswarn_rbtn',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const shipmentId = traceData?.traceData || 2;
        if ([25, 139].includes(shipmentId) > -1) {
          return `type=${shipmentId === 25 ? 2 : 1}`;
        }
      },
    },
  },
  'Checkout.invalid.listItemVisible': {
    operation: ['VISIBLE'],
    title: '失效弹窗商品列表曝光',
    getParse: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const { scmv2 = '', pageName = '' } = args;
        const result = {
          type: 'rec_list',
          item: item.item,
          key: item.key,
          isViewable: item.isViewable,
          index: item.index,
          page: pageName,
          b: pageName,
          c: 'Invalidpoplist',
          d: `${item.index + 1}`,
          iid: '',
          scmv2: scmv2,
        };
        return result;
      },
    },
  },
  'Checkout.subsidy.confirm': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '补贴详情弹窗',
    c: {
      type: 'constant',
      value: 'subsidy_popup_stmt',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { subsidy_status = false, product_id = '' } = traceData || {};
        return `status=${subsidy_status}&goods_ids=${product_id}`;
      },
    },
  },
  'Checkout.areaSubsidy.confirm': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '地补补贴详情弹窗',
    c: {
      type: 'constant',
      value: 'subsidy_city_sign',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Checkout.subsidy.floor': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '补贴楼层',
    c: {
      type: 'variable',
      func: function ({ c }) {
        return c;
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid({ url, actTitle = '' }) {
        const u = url ? `u=${url}&` : '';
        return u + 'act_name=' + actTitle;
      },
    },
  },
  'Checkout.areaSubsidy.floor': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '地补补贴楼层',
    c: {
      type: 'constant',
      value: 'subsidy_city',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Checkout.subsidy.address': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '补贴地址变动弹窗',
    c: {
      type: 'constant',
      value: 'subsidy_popup_relock',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Checkout.subsidy.limit': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '补贴限购弹窗',
    c: {
      type: 'constant',
      value: 'subsidy_popup_quotas',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  getParse_product: {
    type: 'variable',
    func: function getProduct(item = {}, visibleData, args) {
      const { pageName } = args;
      const result = [];
      // 商品信息，不是section的header与footer
      if (item.item.productName) {
        const obj = {
          type: 'product',
          item: item.item,
          isViewable: true,
          key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey,
          index: item.index,
          page: pageName,
          b: pageName,
          c: 'cart_to_detail',
          d: item.item.statIndex,
          area: 'cart_to_detail',
          iid:
            'main_skus=' +
            item.item.ssuId +
            '&product_id=' +
            item.item.itemId +
            '&next=' +
            'product.' +
            item.item.itemId +
            '&u=' +
            `https://m.xiaomiyoupin.com/mfbs/mstd/product?commodityId=${item.item.itemId}&goodsId=${item.item.ssuId}`,
        };

        result.push(obj);

        if (item.item.hasMoreThanOnePid) {
          result.push({
            type: 'product',
            item: item.item,
            isViewable: true,
            key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-switch_sku',
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'switch_sku',
            d: item.item.statIndex,
            area: 'switch_sku',
            iid: 'main_skus=' + item.item.ssuId,
          });
        }

        // 中台打标
        if (item.item.tags && item.item.tags.length) {
          for (let i = 0; i < item.item.tags.length; ++i) {
            result.push({
              type: 'product',
              item: item.item,
              isViewable: true,
              key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-product_labeling',
              index: item.index,
              page: pageName,
              b: pageName,
              c: 'product_labeling',
              d: i + 1,
              area: 'product_labeling',
              iid: 'main_skus=' + item.item.ssuId + '&type=' + encodeURIComponent(item.item.tags[i].name),
            });

            if (item.item.tags[i].tag === 'fcode') {
              result.push({
                type: 'product',
                item: item.item,
                isViewable: true,
                key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-activity_discount',
                index: item.index,
                page: pageName,
                b: pageName,
                c: 'activity_discount',
                d: 1,
                area: 'activity_discount',
                iid: 'main_skus=' + item.item.ssuId + '&type=' + encodeURIComponent('F码'),
              });
            }
          }
        }

        const extraActs = item.item.extraActs || {};

        if (extraActs.actPrefertialInfo) {
          result.push({
            type: 'product',
            item: item.item,
            isViewable: true,
            key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-activity_discount',
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'activity_discount',
            d: 1,
            area: 'activity_discount',
            iid: 'main_skus=' + item.item.ssuId + '&type=' + extraActs.actPrefertialInfo.tagTxt,
          });
        }

        if (extraActs.fsbuy) {
          result.push({
            type: 'product',
            item: item.item,
            isViewable: true,
            key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-activity_discount',
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'activity_discount',
            d: 1,
            area: 'activity_discount',
            iid: 'main_skus=' + item.item.ssuId + '&type=' + extraActs.fsbuy.tagTxt,
          });
        }

        // 有品赠品
        if (extraActs.buyGift && extraActs.buyGift.length > 0) {
          extraActs.buyGift.forEach((gift, index) => {
            result.push({
              type: 'product',
              item: item.item,
              isViewable: true,
              key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-product_service_gift',
              index: item.index,
              page: pageName,
              b: pageName,
              c: 'product_service_gift',
              d: item.item.statIndex * 10000 + 1 + index,
              area: 'product_service_gift',
              iid: 'main_skus=' + item.item.ssuId + '&skus=' + gift.ssuId,
            });
          });
        }

        if (extraActs.buylimitInfo) {
          result.push({
            type: 'product',
            item: item.item,
            isViewable: true,
            key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-activity_discount',
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'activity_discount',
            d: 1,
            area: 'activity_discount',
            iid: 'main_skus=' + item.item.ssuId + '&type=' + extraActs.buylimitInfo.tagTxt,
          });
        }

        if (extraActs.secKill) {
          result.push({
            type: 'product',
            item: item.item,
            isViewable: true,
            key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-activity_discount',
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'activity_discount',
            d: 1,
            area: 'activity_discount',
            iid: 'main_skus=' + item.item.ssuId + '&type=' + extraActs.secKill.tagTxt,
          });
        }

        // 合约机
        if (item.item.properties.miContractInfo) {
          result.push({
            type: 'product',
            item: item.item,
            isViewable: true,
            key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-activity_discount',
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'activity_discount',
            d: 1,
            area: 'activity_discount',
            iid: 'main_skus=' + item.item.ssuId + '&type=' + encodeURIComponent('合约机'),
          });
        }

        if (item.item.checkoutPrice) {
          result.push({
            type: 'product',
            item: item.item,
            isViewable: true,
            key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-hand_price',
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'hand_price',
            d: '1',
            area: 'hand_price',
            iid: 'main_skus=' + item.item.ssuId,
          });
        } else if (item.item.addCartPriceReduce > 0) {
          result.push({
            type: 'product',
            item: item.item,
            isViewable: true,
            key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-cut_price_inform',
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'cut_price_inform',
            d: '1',
            area: 'cut_price_inform',
            iid: '',
          });
        }

        if (item.item.customInfo) {
          result.push({
            type: 'product',
            item: item.item,
            isViewable: true,
            key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-customization',
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'customization',
            d: '1',
            area: 'customization',
            iid: 'main_skus=' + item.item.ssuId,
          });
        }

        const nextAction = item.item.nextAction || [];
        const isRenderBtn = nextAction.indexOf('EDITABLE') > -1 || item.item.canChangeNum;

        if (isRenderBtn) {
          result.push({
            type: 'product',
            item: item.item,
            isViewable: true,
            key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-goodsnum_minus',
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'goodsnum_minus',
            d: '1',
            area: 'goodsnum_minus',
            iid: 'main_skus=' + item.item.ssuId,
          });

          result.push({
            type: 'product',
            item: item.item,
            isViewable: true,
            key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-goodsnum_plus',
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'goodsnum_plus',
            d: '1',
            area: 'goodsnum_plus',
            iid: 'main_skus=' + item.item.ssuId,
          });

          result.push({
            type: 'product',
            item: item.item,
            isViewable: true,
            key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-goodsnum_adjust',
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'goodsnum_adjust',
            d: '1',
            area: 'goodsnum_adjust',
            iid: 'main_skus=' + item.item.ssuId,
          });
        }
      }

      return result;
    },
  },
  'Checkout.imei.input': {
    operation: ['VISIBLE'],
    title: 'imei输入框',
    c: {
      type: 'constant',
      value: 'imei_input',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Checkout.imei.verify': {
    operation: ['TOUCH'],
    title: 'imei确认按钮',
    c: {
      type: 'constant',
      value: 'imei_verify',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Checkout.imei.error': {
    operation: ['VISIBLE'],
    title: 'imei错误信息',
    c: {
      type: 'constant',
      value: 'error_notice',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: ({ type }) => {
        return `type=${type}`;
      },
    },
  },
  'Checkout.imei.resetmatch': {
    operation: ['VISIBLE', 'TOUCH'],
    title: 'imei重新匹配按钮',
    c: {
      type: 'constant',
      value: 'reset_match',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Checkout.cyberdog.bottom': {
    operation: ['touch', 'visible'],
    c: { type: 'constant', value: 'protocol_popups_confirm' },
    d: { type: 'constant', value: '1' },
  },
  'Checkout.errorAddress': {
    operation: ['visible'],
    c: { type: 'constant', value: 'error_address' },
    d: { type: 'constant', value: '1' },
  },
  'Checkout.change.change_time': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '修改时间',
    c: {
      type: 'constant',
      value: 'change_time',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: ({ serve_type, product_id }) => {
        return `serve_type=${serve_type}&product_id=${product_id}`;
      },
    },
  },
  'Checkout.change.modification_time': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '修改时间',
    c: {
      type: 'constant',
      value: 'modification_time',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: ({ serve_type, product_id }) => {
        return `serve_type=${serve_type}&product_id=${product_id}`;
      },
    },
  },
  'Checkout.Delivery.choose_delivery2': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '选择配送方式',
    c: {
      type: 'constant',
      value: 'choose_delivery',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },

  'Checkout.Delivery.choose_delivery3': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '选择配送方式',
    c: {
      type: 'constant',
      value: 'choose_delivery',
    },
    d: {
      type: 'constant',
      value: '2',
    },
  },
  'Checkout.service.store_chosse': {
    operation: ['TOUCH'],
    title: '门店弹层_选中门店',
    c: {
      type: 'constant',
      value: 'store_chosse',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d + 1;
      },
    },
    iid: {
      type: 'variable',
      func: (traceData) => {
        const { store } = traceData;
        return `store_id=${store.orgId}`;
      },
    },
  },
  'Checkout.store.list': {
    operation: ['VISIBLE'],
    title: '列表',
    c: {
      type: 'constant',
      value: 'list',
    },
    getParse: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const { pageName, traceObj } = args;
        const res = [];
        if (item?.item?.orgId) {
          ['store'].forEach((key) => {
            res.push({
              type: key,
              isViewable: item.isViewable,
              key: key + item.index,
              index: item.index + 10001,
              page: pageName,
              b: pageName,
              c: key,
              d: item.index + 10001,
              iid: `org_id=${item?.item?.orgId}`,
            });
          });
          res.push({
            type: 'store_list',
            isViewable: item.isViewable,
            key: 'store_list' + item.index,
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'store_list',
            d: item?.item?.d,
            iid: `org_id=${item?.item?.orgId || ''}&store_id=${traceObj?.selectedNearStoreId}&store_conditions=${
              traceObj?.currentTab === 'near' ? 1 : 2
            }${item?.item?.freqBoughtStore ? '&often_buy=true' : ''}`,
          });
        }
        return res;
      },
    },
  },
  'Checkout.storemodal.store1': {
    operation: ['VISIBLE', 'Touch'],
    c: {
      type: 'constant',
      value: 'store',
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return 1;
      }`,
    },
  },
  'Checkout.main.storelist_tab': {
    operation: ['VISIBLE', 'Touch'],
    title: '店铺列表tab',
    c: {
      type: 'constant',
      value: 'store_conditions',
    },
    d: {
      type: 'variable',
      func: function getIid(traceData) {
        return traceData.d;
      },
    },
  },
  'Checkout.store.store_chosse': {
    operation: ['Touch'],
    c: {
      type: 'constant',
      value: 'store_list',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData?.d;
      },
    },
    iid: {
      type: 'variable',
      func: (traceData) => {
        const { store, selectedNearStoreId, currentTab, oftenBuy } = traceData;
        return `store_id=${store.orgId}&store_id=${selectedNearStoreId}&store_conditions=${
          currentTab === 'near' ? '1' : '2'
        }${oftenBuy ? '&often_buy=true' : ''}`;
      },
    },
  },
  'Checkout.storemodal.store2': {
    operation: ['VISIBLE', 'Touch'],
    c: {
      type: 'constant',
      value: 'store',
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return 2;
      }`,
    },
  },
  'Checkout.storemodal.store_done': {
    operation: ['VISIBLE', 'Touch'],
    c: {
      type: 'constant',
      value: 'store_done',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: (traceData) => {
        const { store } = traceData;
        return `org_id=${store?.orgId || store?.orgCode || ''}`;
      },
    },
  },
};
export default config;
